module.exports = __webpack_public_path__ + "static/media/logo_concamin-agua.9cf8e858.png";